module.exports = __webpack_public_path__ + "static/media/figma.6ffd8b8d.svg";